import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Reaction } from '@portals/api';

@Pipe({
	name: 'reaction',
})
export class ReactionPipe implements PipeTransform {
	constructor(private percent: PercentPipe) {}

	transform(value?: Reaction, ...args: unknown[]): string {
		return value ? `${value.icon}   ${this.percent.transform(value.percentage || 0)}` : '-';
	}
}
